<template>
  <a-layout-sider collapsible width="180" style="background-color: #ffffff" :class="classObj" :trigger="null">
    <div style="height: 50px; line-height: 50px; padding: 0 20px; color: #999999">人资管理系统</div>
    <div class="scrollbar">
      <div class="scrollbar-content">
        <a-menu class="ehf-menu" mode="inline" :selectedKeys="selectedKeys" v-model:openKeys="openKeys">
          <ehfMenuChild v-for="route in routes" :key="route.path" :item="route" />
        </a-menu>
      </div>
    </div>
  </a-layout-sider>
</template>

<script>
  import ehfMenuChild from './ehf-menu'
  import { mapGetters } from 'vuex'
  export default {
    name: 'HrmSide',
    components: {
      ehfMenuChild,
    },
    data() {
      return {
        selectedKeys: [],
        openKeys: [],
      }
    },
    watch: {
      $route: {
        handler({ path, matched }) {
          this.selectedKeys = [path]
          this.openKeys = [matched[0].path]
        },
        immediate: true,
      },
    },
    computed: {
      ...mapGetters({
        collapse: 'settings/collapse',
        routes: 'routes/hrmRouters',
      }),
      classObj() {
        return {
          'ehf-collapse': this.collapse,
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .scrollbar {
    overflow: hidden;
    height: calc(100% - 75px);
  }

  .scrollbar-content {
    height: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
    margin-right: -10px; /* 隐藏右侧滚动条 */
    margin-bottom: -10px; /* 隐藏底部滚动条 */
  }
  .ehf-sider {
    position: fixed;
    left: 0;
    height: 100vh;
    overflow: auto;
  }
</style>
